<template>
  <ApplicationLayout>
    <v-container
      fluid
      px-12
      py-6
      v-if="ready"
    >
      <BackTitle
        :to="{
          name: 'resellers',
          query: { focus: reseller.id }
        }"
        :title="title"
        :subtitle="resellerName"
      ></BackTitle>

      <v-card
        class="pa-6 mt-6"
      >
        <v-row>
          <v-col
            cols="6"
            offset="3"
          >
            <v-form
              @submit.prevent="submit()"
              ref="form"
              v-model="valid"
            >
              <v-text-field
                v-model="reseller.name"
                label="Name"
                :rules="rules.name"
              ></v-text-field>

              <div class="d-flex">
                <v-spacer></v-spacer>

                <v-btn
                  :disabled="!valid"
                  color="primary"
                  type="submit"
                  class="mr-4"
                  depressed
                >Save</v-btn>

                <v-btn
                  :disabled="!valid"
                  color="primary"
                  @click="saveAndGoBack()"
                  depressed
                >Save & Go back</v-btn>
              </div>
            </v-form>
          </v-col>
        </v-row>
      </v-card>
    </v-container>
  </ApplicationLayout>
</template>

<script>
import { mapState } from 'vuex'
import ApplicationLayout from '../components/layouts/ApplicationLayout.vue'
import BackTitle from '../components/BackTitle.vue'

export default {
  components: {
    ApplicationLayout,
    BackTitle
  },
  data() {
    return {
      valid: false,
      ready: false,
      editMode: !!this.$route.params.id,
      rules: {
        name: [v => !!v || 'Name is required']
      }
    }
  },
  computed: {
    ...mapState('Resellers', ['reseller', 'resellerName']),
    title() {
      return this.editMode ? 'Reseller' : 'Create new reseller'
    }
  },
  async created() {
    await this.getReseller(this.$route.params.id)
    this.ready = true
  },
  methods: {
    async getReseller(id) {
      await this.$store.dispatch('Resellers/get', id)
    },
    async submit() {
      if (!this.$refs.form.validate()) return
      const snackbar = { text: 'Reseller update succeed' }
      try {
        await this.$store.dispatch('Resellers/createOrUpdate')
        if (!this.editMode) {
          this.$router.push({ name: 'reseller', params: { id: this.reseller.id } })
          snackbar.text = 'Reseller creation succeed'
          this.editMode = true
        }
      } catch (error) {
        snackbar.text = this.editMode ? 'Reseller update failed' : 'Reseller creation failed'
        snackbar.color = 'error'
      }
      this.$store.commit('Global/setSnackbar', snackbar)
    },
    async saveAndGoBack() {
      await this.submit()
      this.$router.push({ name: 'resellers' })
    }
  },
  async beforeRouteUpdate(to, from, next) {
    if (to.name === from.name && to.params.id !== from.params.id) {
      await this.getReseller(to.params.id)
    }
    next()
  },
  beforeRouteLeave(to, from, next) {
    if (from.name !== 'new-reseller') {
      this.$store.commit('Resellers/setReseller', null)
    }
    next()
  }
}
</script>
